export default function TestimonialSection() {
  return (
    <section className="py-20 md:py-28 px-6 md:px-10 bg-background-100">
      <div className="max-w-7xl mx-auto flex flex-col lg:flex-row gap-12 lg:gap-16 items-center">
        <div className="lg:w-[40%] w-full">
          <div className="rounded-3xl overflow-hidden h-[420px] w-full">
            <img
              src="https://readdy.ai/api/search-image?query=Diverse%20group%20of%20friends%20unboxing%20packages%20together%20in%20bright%20modern%20apartment%2C%20genuine%20excitement%20expressions%2C%20natural%20window%20light%2C%20colorful%20decor%2C%20editorial%20lifestyle%20photography%2C%20authentic%20joyful%20moment%2C%20warm%20community%20feeling&width=800&height=840&seq=testimonial-v3&orientation=portrait"
              alt="Satisfied AllChinaBuySpreadsheet users"
              className="w-full h-full object-cover object-top"
            />
          </div>
        </div>

        <div className="lg:w-[60%]">
          <span className="text-xs font-medium text-foreground-500">
            (Editorial Review)
          </span>
          <h3 className="mt-3 text-3xl md:text-4xl font-heading font-bold text-foreground-950 leading-tight">
            Trusted by 10,000+<br />
            <span className="text-foreground-400">Global Buyers</span>
          </h3>
          <blockquote className="mt-8 text-lg text-foreground-600 leading-relaxed max-w-xl">
            &ldquo;AllChinaBuySpreadsheet helped me cut sourcing time by 80% with structured
            daily updates and scam-filtered lists. Before discovering this platform, I spent
            hours comparing products across different marketplaces. Now everything I need is
            organized in one clean, verified spreadsheet that updates automatically.&rdquo;
          </blockquote>
          <p className="mt-6 text-sm font-semibold text-foreground-800">
            &mdash; Power User from US
          </p>

          <div className="flex items-center gap-3 mt-10">
            <button
              className="w-10 h-10 flex items-center justify-center rounded-full border border-foreground-300 text-foreground-500 hover:border-foreground-500 hover:text-foreground-700 transition-colors cursor-pointer"
              aria-label="Previous review"
            >
              <i className="ri-arrow-left-line"></i>
            </button>
            <button
              className="w-10 h-10 flex items-center justify-center rounded-full bg-foreground-950 text-background-50 hover:bg-foreground-800 transition-colors cursor-pointer"
              aria-label="Next review"
            >
              <i className="ri-arrow-right-line"></i>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}